'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SearchToggle = require('./SearchToggle.scss');

var _SearchToggle2 = _interopRequireDefault(_SearchToggle);

var _SearchField = require('./SearchField');

var _SearchField2 = _interopRequireDefault(_SearchField);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _IconPath = require('../../services/IconPath');

var _IconPath2 = _interopRequireDefault(_IconPath);

var _Image = require('../../managewidgets/components/image/Image');

var _Image2 = _interopRequireDefault(_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchToggle = function (_React$Component) {
  (0, _inherits3.default)(SearchToggle, _React$Component);

  function SearchToggle(props) {
    (0, _classCallCheck3.default)(this, SearchToggle);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchToggle.__proto__ || (0, _getPrototypeOf2.default)(SearchToggle)).call(this, props));

    _this.toggleSearch = function () {
      _this.setState(function (prevState) {
        return {
          showSearch: !prevState.showSearch
        };
      });
    };

    _this.onSearchBlur = function () {
      if (!_this.props.value) {
        _this.toggleSearch();
      }
    };

    _this.state = {
      showSearch: _this.props.value
    };
    return _this;
  }

  (0, _createClass3.default)(SearchToggle, [{
    key: 'render',
    value: function render() {
      if (this.state.showSearch) {
        return _react2.default.createElement(_SearchField2.default, {
          automationName: 'search',
          className: this.props.fieldClassName,
          value: this.props.value,
          onChange: this.props.onChange,
          onBlur: this.onSearchBlur,
          placeholderText: this.props.placeholderText,
          onSearch: this.props.onSearch });
      }

      return _react2.default.createElement(_Image2.default, {
        automationName: 'search',
        className: (0, _classnames2.default)(_SearchToggle2.default.searchIcon, this.props.iconClassName),
        src: _IconPath2.default.get('Action_Search'),
        onClick: this.toggleSearch });
    }
  }]);
  return SearchToggle;
}(_react2.default.Component);

;

exports.default = SearchToggle;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/search/SearchToggle.js
// module id = 357
// module chunks = 10